import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, Button } from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import { userRoleMapper } from '../../mappers';
import EditUserDialog from '../../containers/EditUserDialog';

import EditUserFromBranchDialog from '../../containers/EditUserFromBranchDialog';
// import EditUserDialog from '../../containers/EditUserDialog';

// import { companyStatus } from '../../constants';

import DeleteUserDialog from './../../containers/DeleteUserDialog';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
  userName: {
    fontSize: 18,
    fontWeight: 800,
    paddingTop: theme.spacing(1)
  },
  email: {
    paddingTop: theme.spacing(1)
  },
  deactivateContainer: {
    paddingTop: theme.spacing(2)
  },
  editDeleteContainer: {
    // paddingTop: theme.spacing(1)
  },
  editButton: {
    color: theme.palette.secondary.main
  },
  deleteButton: {
    color: theme.palette.danger.main
  },
  bold: {
    fontWeight: 600
  }
}));

const SingleUser = (props) => {
  const classes = useStyles();
  const { user, handleUserEditClick, handlDeleteUserDialog } = props;

  const isDeletable = user && user.role > 1;

  return (
    <React.Fragment>
      <Paper>
        <div className={classes.container}>
          <Grid container>
            <Grid item xs={6}>
              <div className={classes.companyDetails}>
                <Typography variant="h3" className={classes.userName}>
                  {user && user.name}
                </Typography>
                <Typography variant="subtitle1" className={classes.email}>
                  <span className={classes.bold}>Email:</span>{' '}
                  {user && user.email}
                </Typography>
                <Typography variant="subtitle1" className={classes.email}>
                  <span className={classes.bold}>Role:</span>{' '}
                  {user && userRoleMapper.mapUserRole(user.role)}
                </Typography>
                <Typography variant="subtitle1" className={classes.email}>
                  <span className={classes.bold}>Status: </span>{' '}
                  {user && user.status && 'Active'}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.deactivateContainer}>
                <Button
                  startIcon={<BlockIcon />}
                  //   onClick={() =>
                  //     openDeleteOrDeactiveCompanyDialog(
                  //       true,
                  //       companyId,
                  //       companyStatus.DEACTIVE
                  //     )
                  //   }
                  style={{ visibility: 'hidden' }}
                >
                  Deactivate
                </Button>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.editDeleteContainer}>
                <Button
                  startIcon={<EditIcon />}
                  className={classes.editButton}
                  onClick={() => handleUserEditClick({ ...user })}
                >
                  Edit
                </Button>
                {isDeletable && (
                  <Button
                    startIcon={<DeleteOutlineIcon />}
                    className={classes.deleteButton}
                    onClick={() => handlDeleteUserDialog(true, { ...user })}
                  >
                    Delete
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </React.Fragment>
  );
};

const UsersList = (props) => {
  const {
    users,
    fetchAllUsers,
    onUserEditClick,
    isForBranch,
    onOpenDeleteUserDialog
  } = props;

  React.useEffect(() => {
    fetchAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUserEditClick = (company) => {
    onUserEditClick(company);
  };

  if (!users) {
    return;
  }

  const handlDeleteUserDialog = (open, user) => {
    onOpenDeleteUserDialog(open, user);
  };

  return (
    <React.Fragment>
      {isForBranch && <EditUserFromBranchDialog />}

      {!isForBranch && <EditUserDialog />}

      <DeleteUserDialog />

      <div>
        {users &&
          users.map((user) => {
            return (
              <SingleUser
                user={user}
                key={user.id}
                handleUserEditClick={handleUserEditClick}
                handlDeleteUserDialog={handlDeleteUserDialog}
              />
            );
          })}
      </div>
    </React.Fragment>
  );
};

export default UsersList;
